<template>
  <div>
    <v-app-bar color="#FFFFFF" class="flex-grow-0" app light flat>
      <v-app-bar-nav-icon color="#1B2559" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      
      <v-spacer></v-spacer>
      
      <v-toolbar-title class="d-flex justify-center" style="width: 200px;">
        <!-- Solo el logo, sin avatar ni borde -->
        <v-img
          :src="logoUrl"
          alt="Logo"
          contain
          height="85"
          max-width="160"
          class="mx-auto"
        ></v-img>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <v-btn icon @click="salir">
        <v-icon color="#4318FF">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer 
      app 
      v-model="drawer" 
      color="#FFFFFF" 
      light 
      width="280"
      floating
      elevation="2"
    >
      <v-layout column align-center class="mt-8 mb-6">
        <v-avatar size="90" class="mb-4 elevation-4" style="border: 3px solid #4318FF; background-color: white;">
          <v-img
            :src="logoUrl"
            alt="Logo"
            contain
            max-width="80%"
          ></v-img>
        </v-avatar>

        <div class="text-h6 font-weight-bold text-center px-4" style="color: #1B2559;">
          {{ nombreGimnasio }}
        </div>

        <div class="subtitle-2 mt-1">
          <span style="color: #A3AED0;">Hola, </span>
          <span class="font-weight-black" style="color: #1B2559;">
            {{ usuarioLogin }}
          </span>
        </div>
      </v-layout>

      <v-divider class="mx-4 mb-4" style="border-color: #F4F7FE;"></v-divider>

      <v-list dense nav class="px-4">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
          class="mb-2 rounded-xl"
          active-class="active-item" 
        >
          <v-list-item-icon class="mr-4">
            <v-icon size="22">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title style="font-weight: 600; font-size: 0.95rem;">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Utiles from '../Servicios/Utiles'
export default {
  name: "Encabezado",

  data: () => ({
    drawer: true,
    usuarioLogin: "",
    nombreGimnasio: "",
    logo: "",
    items: [],
  }),

  computed: {
    logoUrl() {
      return Utiles.generarURL(this.logo, 'ajustes');
    }
  },

  mounted(){
   
    this.usuarioLogin = localStorage.getItem("nombreUsuario") || localStorage.getItem("usuario") || "Admin";
    this.nombreGimnasio = localStorage.getItem("nombreGimnasio") || "LIVE FIT";
    this.logo = localStorage.getItem("logoGimnasio");
    // Construir menú dinámico y añadir auditoría solo si rol === '1'
    const rol = localStorage.getItem('rol');
    const base = [
      { title: "Inicio", icon: "mdi-view-dashboard", link: "/" },
      { title: "Registrar visita", icon: "mdi-home-account", link: "/registrar-visita" },
      { title: "Punto de Venta", icon: "mdi-cash-register", link: "/ventas" },
      { title: "Usuarios", icon: "mdi-account-box", link: "/usuarios" },
      { title: "Miembros", icon: "mdi-weight-lifter", link: "/miembros" },
      { title: "Membresías", icon: "mdi-wallet-membership", link: "/membresias" },
      { title: "Pagos", icon: "mdi-account-cash", link: "/pagos" },
      { title: "Visitas", icon: "mdi-calendar-star", link: "/visitas" },
      { title: 'Reporte Ventas', icon: 'mdi-file-chart', link: '/reporte-ventas' },
      { title: "Inventario", icon: "mdi-package-variant", link: "/inventario" },
      { title: "Configurar", icon: "mdi-cog", link: "/configurar" },
      { title: "Mi perfil", icon: "mdi-account-key", link: "/perfil" },
    ];
    if(rol === '1' || rol === 1){
      base.splice(10, 0, { title: "Auditoría", icon: "mdi-file-document-box-search", link: "/auditoria" });
    }
    this.items = base;
  },

  methods:{ 
    salir(){
      localStorage.removeItem('logeado');
      localStorage.removeItem('idUsuario');
      localStorage.removeItem('nombreUsuario');
      localStorage.removeItem('usuario');
      window.location.reload();
    },

    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },
  }
};
</script>

<style scoped>
/* Color de iconos por defecto */
.v-list-item .v-icon {
  color: #A3AED0;
}

/* Efecto al seleccionar un item (Igual que el diseño moderno) */
.active-item {
  background-color: #4318FF !important;
  color: #FFFFFF !important;
  box-shadow: 0px 4px 12px rgba(67, 24, 255, 0.3);
}

.active-item .v-icon {
  color: #FFFFFF !important;
}

/* Ajustes de scrollbar claros */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: #F4F7FE; 
}
::-webkit-scrollbar-thumb {
  background: #CBD5E0; 
  border-radius: 10px;
}
</style>

<style>
/* Estándar visual para botones de acción (íconos) en tablas / listados */
/* Cubrimos las variantes habituales de Vuetify: .v-btn.icon y .v-btn--icon */
.v-btn.icon,
.v-btn.v-btn--icon,
.v-btn--icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: background .15s ease, transform .08s ease;
  padding: 0;
}
.v-btn.icon .v-icon,
.v-btn.v-btn--icon .v-icon,
.v-btn--icon .v-icon {
  font-size: 18px !important;
  color: #4318FF !important;
}
.v-btn.icon:hover,
.v-btn.v-btn--icon:hover,
.v-btn--icon:hover {
  background: rgba(67,24,255,0.06);
  transform: translateY(-1px);
}

/* Estilos semánticos para usar en markup si se desea */
.v-btn.action-primary.v-btn--icon .v-icon,
.v-btn.action-primary.icon .v-icon { color: #4318FF !important; }
.v-btn.action-danger.v-btn--icon .v-icon,
.v-btn.action-danger.icon .v-icon  { color: #EE5D50 !important; }
.v-btn.action-edit.v-btn--icon .v-icon,
.v-btn.action-edit.icon .v-icon    { color: #05CD99 !important; }

/* Avatares en listados: tamaño y borde uniforme */
.v-avatar.list-avatar { width: 45px; height: 45px; border-radius: 8px; border: 1px solid #ECEFF7; }

/* Estándar para cabeceras/labels en tablas */
.table-label { font-weight: 700; color: #1B2559; font-size: 0.95rem; }
</style>


// WEBPACK FOOTER //
// src/components/Encabezado.vue